module.exports = __webpack_public_path__ + "img/religions.0a126d7e.svg";